import { Pipe, PipeTransform } from '@angular/core';

import { DatumCell } from './models';

@Pipe({
  name: 'rdsIncludeSubtotals'
})
export class RdsIncludeSubtotalsPipe implements PipeTransform {
  transform(cells: Array<DatumCell>, hasRowSubtotals: boolean): Array<DatumCell> {
    return !hasRowSubtotals ? cells.filter(cell => !cell.subtotal) : cells;
  }
}
